// @flow
import React from 'react';
import * as Clone from 'clone';

import styles from './modalWithMultiSelectList.scss';

import MultiSelectList from '../formElements/multiSelectList/multiSelectList';

import Modal from '../modal/modal';

type Props = {
  showLoader: boolean,
  showModal: boolean,
  title: string,
  closeModal: Function,
  multiSelectListArr: Array<any>,
  multiSelectListArrOriginal: Array<any>,
  accessorKeys: Object,
  onSave: Function
};

type State = {
  // multiSelectListArrOriginal: Array<any>,
  multiSelectListArrMutated: Array<any>
};

class ModalWithMultiSelectList extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      // multiSelectListArrOriginal: Clone.default(this.props.multiSelectListArr),
      multiSelectListArrMutated: Clone.default(this.props.multiSelectListArr)
    };
    this.accessorKeys = this.props.accessorKeys;
    this.keyName = this.accessorKeys.key || 'key';
    this.selectFlag = this.accessorKeys.selectFlag || 'isSelected';
  }

  componentWillReceiveProps(nextProps: Object) {
    this.setLists(nextProps);
  }

  onOptionSelect(obj: Object, i: number) {
    const selectedElem = this.state.multiSelectListArrMutated[i];
    if (!selectedElem[this.selectFlag]) {
      selectedElem[this.selectFlag] = true;
    } else {
      selectedElem[this.selectFlag] = false;
    }
    this.setState({
      multiSelectListArrMutated: this.state.multiSelectListArrMutated
    });
  }

  onSaveClick() {
    // eslint-disable-next-line no-console
    console.log('save settings');
    if (this.props.onSave) {
      this.props.onSave(this.state.multiSelectListArrMutated);
    }
  }

  setLists(nextProps: Object) {
    this.setState({
      // multiSelectListArrOriginal: Clone.default(nextProps.multiSelectListArr),
      multiSelectListArrMutated: Clone.default(nextProps.multiSelectListArr)
    });
  }

  applyFilter(filterName: string) {
    let modifiedArr = [];
    if (filterName === 'restoreDefault' || filterName === 'selectAll') {
      modifiedArr = this.state.multiSelectListArrMutated.map(elem => {
        elem[this.selectFlag] = true;
        return elem; // for eslint
      });
    } else if (filterName === 'none') {
      modifiedArr = this.state.multiSelectListArrMutated.map(elem => {
        elem[this.selectFlag] = false;
        return elem; // for eslint
      });
    }

    this.setState({
      multiSelectListArrMutated: modifiedArr
    });
  }

  accessorKeys: Object;
  keyName: string;
  selectFlag: string;
  renderFilters() {
    return (
      <div className={`${styles.filtersWrapper} l-row j-space-bet`}>
        <div
          className={`${styles.filterBtn} restore-default-filter l-row j-center a-center`}
          onClick={() => this.applyFilter('restoreDefault')}
        >
          Restore Default
        </div>
        <div
          className={`${styles.filterBtn} ${styles.allFilter} l-row j-center a-center`}
          onClick={() => this.applyFilter('selectAll')}
        >
          All
        </div>
        <div
          className={`${styles.filterBtn} ${styles.noneFilter} l-row j-center a-center`}
          onClick={() => this.applyFilter('none')}
        >
          None
        </div>
      </div>
    );
  }
  render() {
    return (
      <Modal
        showLoader={this.props.showLoader}
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={this.props.closeModal}
      >
        <div className={`${styles.modalWithMultiSelectListWrapper}`}>
          {this.renderFilters()}
          <div className={`${styles.listContainer}`}>
            <MultiSelectList
              optionsArr={this.state.multiSelectListArrMutated}
              onSelect={(obj, i) => this.onOptionSelect(obj, i)}
              accessorKeys={this.accessorKeys}
            />
          </div>

          <div className={`${styles.btnWrapepr} l-row j-end`}>
            <div
              className={`${styles.cancelBtn} ${styles.footerBtn} l-row a-center j-center`}
              onClick={() => this.props.closeModal()}
            >
              Cancel
            </div>
            <div
              className={`${styles.saveBtn} ${styles.footerBtn} l-row a-center j-center`}
              onClick={() => this.onSaveClick()}
            >
              Save
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ModalWithMultiSelectList;
